// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeOffPolicies_wrapper__MJtiz","controls":"TimeOffPolicies_controls__5zVFY","searchWrapper":"TimeOffPolicies_searchWrapper__wwtvh"};